export default "__VITE_ASSET__xAJw3bIlmtAqlvUWulhaHA__";